function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import log from '../utility/debug.js';
import { useRef, useMemo, useCallback } from 'react';
export default function useItemKeys(_ref) {
  var getItemId = _ref.getItemId;
  // These "listeners" will be called in case the auto-generated item keys are reset
  // due to the prefix counter number reaching its maximum allowed value.
  var itemKeysResetEventListeners = useMemo(function () {
    return [];
  }, []); // Adds an "on item keys reset" listener.

  var onItemKeysReset = useCallback(function (listener) {
    itemKeysResetEventListeners.push(listener);
  }, []); // List items are rendered with `key`s so that React doesn't
  // "reuse" `itemComponent`s in cases when `items` are changed.

  var itemKeyPrefix = useRef(); // When no `getItemId()` function is specified, it creates an item key
  // from an auto-generated unique prefix and the item's index in the `items` array.
  // This way, when the `items` change, their keys are also changed.

  var generateItemKeyPrefix = useMemo(function () {
    var counter = 0;

    function getNextCounter() {
      if (counter === Number.MAX_SAFE_INTEGER) {
        for (var _iterator = _createForOfIteratorHelperLoose(itemKeysResetEventListeners), _step; !(_step = _iterator()).done;) {
          var listener = _step.value;
          listener();
        }

        counter = 0;
      }

      counter++;
      return counter;
    }

    return function () {
      itemKeyPrefix.current = String(getNextCounter());
    };
  }, [itemKeyPrefix, itemKeysResetEventListeners]);
  useMemo(function () {
    // Generate an initial unique `key` prefix for list items.
    generateItemKeyPrefix();
  }, []); // If `getItemId()` function is defined, then item `id`s are gonna be the item element `key`s.

  var usesAutogeneratedItemKeys = !getItemId;
  var generateItemKeyPrefixIfNotUsingItemIds = useCallback(function () {
    if (usesAutogeneratedItemKeys) {
      generateItemKeyPrefix();
      log('React: ~ Item key prefix:', itemKeyPrefix.current);
    }
  }, [usesAutogeneratedItemKeys, generateItemKeyPrefix]);
  /**
   * Returns a `key` for an `item`'s element.
   * @param  {object} item — The item.
   * @param  {number} i — Item's index in `items` list.
   * @return {any}
   */

  var getItemKey = useCallback(function (item, i) {
    if (getItemId) {
      return String(getItemId(item));
    }

    return "".concat(itemKeyPrefix.current, ":").concat(i);
  }, [getItemId, itemKeyPrefix]);
  return {
    getItemKey: getItemKey,
    onItemKeysReset: onItemKeysReset,
    usesAutogeneratedItemKeys: usesAutogeneratedItemKeys,
    updateItemKeysForNewItems: generateItemKeyPrefixIfNotUsingItemIds
  };
}
//# sourceMappingURL=useItemKeys.js.map